export enum OPTION_DISCOUNT {
  DISCOUNT10 = "10% OFF",
  DISCOUNT15 = "15% OFF",
  DISCOUNT20 = "20% OFF",
  DISCOUNT25 = "25% OFF",
  DISCOUNT30 = "30% OFF",
  DISCOUNT35 = "35% OFF",
  DISCOUNT40 = "40% OFF",
  DISCOUNT45 = "45% OFF",
  DISCOUNT50 = "50% OFF",
  DISCOUNT55 = "55% OFF",
  DISCOUNT60 = "60% OFF",
  DISCOUNT65 = "65% OFF",
  DISCOUNT70 = "70% OFF",
  DISCOUNT75 = "75% OFF",
  NUMBER10 = 10,
  NUMBER15 = 15,
  NUMBER20 = 20,
  NUMBER25 = 25,
  NUMBER30 = 30,
  NUMBER35 = 35,
  NUMBER40 = 40,
  NUMBER45 = 45,
  NUMBER50 = 50,
  NUMBER55 = 55,
  NUMBER60 = 60,
  NUMBER65 = 65,
  NUMBER70 = 70,
  NUMBER75 = 75,
}
